import React from 'react';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../ui/table';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { Trash2, FileText, AlertCircle } from 'lucide-react';

const GSTR1RecordsList = ({ records, onDelete, tileId }) => {
  if (!records || records.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <FileText className="w-8 h-8 text-gray-400" />
        </div>
        <p className="text-gray-500 mb-2">No records added yet</p>
        <p className="text-sm text-gray-400">Click "Add Record" to add invoice details</p>
      </div>
    );
  }

  const showGSTIN = ['4A', '9B', '10'].includes(tileId);

  const getTotalTax = () => {
    let igst = 0, cgst = 0, sgst = 0;
    records.forEach(record => {
      igst += parseFloat(record.igst || 0);
      cgst += parseFloat(record.cgst || 0);
      sgst += parseFloat(record.sgst || 0);
    });
    return { igst: igst.toFixed(2), cgst: cgst.toFixed(2), sgst: sgst.toFixed(2) };
  };

  const totals = getTotalTax();

  return (
    <div className="space-y-4">
      <div className="rounded-lg border overflow-hidden">
        <Table>
          <TableHeader className="bg-gray-50">
            <TableRow>
              <TableHead className="w-[50px]">#</TableHead>
              {showGSTIN && <TableHead>GSTIN</TableHead>}
              <TableHead>Invoice No.</TableHead>
              <TableHead>Date</TableHead>
              <TableHead>Place of Supply</TableHead>
              <TableHead className="text-right">Taxable Value</TableHead>
              <TableHead className="text-right">Rate</TableHead>
              <TableHead className="text-right">IGST</TableHead>
              <TableHead className="text-right">CGST</TableHead>
              <TableHead className="text-right">SGST</TableHead>
              <TableHead className="w-[80px]">Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {records.map((record, index) => (
              <TableRow key={record.id} className="hover:bg-blue-50/50">
                <TableCell className="font-medium">{index + 1}</TableCell>
                {showGSTIN && <TableCell className="font-mono text-xs">{record.gstin}</TableCell>}
                <TableCell className="font-medium">{record.invoiceNo}</TableCell>
                <TableCell>{record.invoiceDate}</TableCell>
                <TableCell>{record.placeOfSupply}</TableCell>
                <TableCell className="text-right font-medium">₹{parseFloat(record.taxableValue).toLocaleString()}</TableCell>
                <TableCell className="text-right">
                  <Badge variant="outline">{record.rate}%</Badge>
                </TableCell>
                <TableCell className="text-right text-green-600">₹{record.igst}</TableCell>
                <TableCell className="text-right text-green-600">₹{record.cgst}</TableCell>
                <TableCell className="text-right text-green-600">₹{record.sgst}</TableCell>
                <TableCell>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={() => onDelete(record.id)}
                    className="text-red-500 hover:text-red-700 hover:bg-red-50"
                  >
                    <Trash2 className="w-4 h-4" />
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </div>

      {/* Summary Footer */}
      <div className="flex flex-wrap justify-between items-center gap-4 p-4 bg-[#0D1B2A] text-white rounded-lg">
        <div className="flex items-center gap-2">
          <AlertCircle className="w-5 h-5" />
          <span className="font-medium">Total Records: {records.length}</span>
        </div>
        <div className="flex gap-6">
          <div className="text-center">
            <p className="text-xs text-blue-200">Total IGST</p>
            <p className="font-bold">₹{totals.igst}</p>
          </div>
          <div className="text-center">
            <p className="text-xs text-blue-200">Total CGST</p>
            <p className="font-bold">₹{totals.cgst}</p>
          </div>
          <div className="text-center">
            <p className="text-xs text-blue-200">Total SGST</p>
            <p className="font-bold">₹{totals.sgst}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GSTR1RecordsList;
